// AddToWishlistNotification helper functions and data

export const defaultImageConfig = {
  width: 50,
  height: 50
};
